import * as core from 'hub-http/middlewares/core';
import { onResponse } from 'hub-http/middlewares/core';
import { ERROR_STATUS_CODES, RETRY_MIDDLEWARE_ATTEMPTS_AMOUNT, STATUS_CODES } from '../../constants/Http';
import { API_RETRY_TIMEOUT } from '../../constants/timeouts';
const shouldRetry = response => response.status === STATUS_CODES.INTERNAL_ERROR || response.status === STATUS_CODES.RATE_LIMIT || response.status === STATUS_CODES.NETWORKERROR && response.errorCode === ERROR_STATUS_CODES.NETWORKERROR;
const retryMiddleware = core.retry(shouldRetry, {
  reason: 'Server error',
  maxRetries: RETRY_MIDDLEWARE_ATTEMPTS_AMOUNT,
  delay: API_RETRY_TIMEOUT
});

// need to detect retry logic and prevent triggering
// other middlewares extra times
export const detectRetryMiddleware = options => onResponse(response => {
  if (shouldRetry(response) && response.options.retryAttempts !== RETRY_MIDDLEWARE_ATTEMPTS_AMOUNT) {
    response.isErrorHandled = true;
  }
  return response;
})(options);
export default retryMiddleware;